import { Action, Mutation, Module } from "vuex-class-modules";
import Axios, { AxiosResponse } from "axios";
import ProfileViewModel from "@/models/ProfileViewModel";
import AxiosSecureModule from "./axiosSecureModule";
import { Log } from "@/plugins/Logging";
@Module({})
export default class ProfileModule extends AxiosSecureModule {
    public profile: ProfileViewModel = new ProfileViewModel();

    @Action
    public async Get() {
        await this.defineHeaderAxios();
        Axios.get("api/Profile")
            .then((result: AxiosResponse) => {
                this.Set(result.data);
            })
            .catch((error) => {
                Log.error("", error);
            });
    }
    @Action
    public async Update(model: ProfileViewModel) {
        await this.defineHeaderAxios();
        Axios.put("api/Profile", model)
            .then((result: AxiosResponse) => {
                if (result.status === 200) {
                    this.Get();
                }
            })
            .catch((error) => {
                Log.error("", error);
            });
    }

    @Mutation
    Set(data: ProfileViewModel) {
        this.profile = data;
    }
}
